import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import { getSubjectsByClass } from "../../api/subjects.js";

import "./class_page.css";

const ClassPage = ({ userName, userRoles }) => {
  const { id } = useParams();

  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await getSubjectsByClass(id);
        if (alive) setSubjects(Array.isArray(data) ? data : []);
      } catch (e) {
        const status = e?.response?.status;
        const message =
          e?.response?.data?.message ||
          e?.response?.data ||
          e?.message ||
          "Ошибка загрузки";

        if (alive) setError(status ? `${status}: ${message}` : String(message));
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, [id]);

  return (
    <>
      <Header userName={userName} userRoles={userRoles} />

      <div className="classContainer">
        {loading && <div>Завантаження...</div>}
        {error && <div style={{ color: "red" }}>{error}</div>}

        {!loading && !error && (
          <ListGroup>
            {subjects.map((s) => (
              <ListGroup.Item
                key={s.id || `${s.classId}-${s.subjectSlug}`}
                action
                as={Link}
                to={`/class/${id}/${s.subjectSlug}`}
                variant="info"
                className="list-item"
              >
                {s.title}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </div>

      <Footer />
    </>
  );
};

export default ClassPage;
